import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";
import {
  setAllBannners,
  removeBanner,
  addBanner,
  setBannerCurrentPage,
  setBannerTotalPages,
} from "redux/actions/Banner";

import axios from "../auth/jwt/config";

const BannerReguests = {
  getAllBanners: (page, position) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/banner/getall?page=${page}&limit=5&searchString=${position}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllBannners(data.docs));
            dispatch(setBannerCurrentPage(data.page));
            dispatch(setBannerTotalPages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  createBanner: (banner) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        try {
          axios
            .post(`/banner/create`, banner)
            .then(({ data }) => {
              dispatch(fetchSuccess("با موفقیت اضافه شد"));
              dispatch(addBanner(data));
              resolve(data);
            })
            .catch((error) => {
              if (error.response) {
                reject(error.response.data.msgFa);
              } else {
                reject(error.message);
              }
            });
        } catch (error) {
          dispatch(fetchError(error.message));
          reject(error.message);
        }
      });
    };
  },
  removeSingleBanner: (id) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/banner/delete/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(removeBanner(id));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateSingleBanner: (id, data) => {
    return (dispatch) => {
      try {
        axios
          .patch(`/banner/update/${id}`, data)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت به روز رسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getSuggestedIndex: async () => {
    let index = 0;
    try {
      const response = await axios.get(`/banner/suggestedIndex`);
      index = response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.msgFa);
      } else {
        console.log(error.message);
      }
    }
    return index;
  },
};

export default BannerReguests;
